import styled from '@emotion/styled';
import {
  BlockContentWrapper,
  BlockWrapper,
  BlockHeader,
  BlockTitle,
  CUSTOM_BREAK_POINT,
  BackgroundImage,
} from '../Block.styled';
import Button from 'components/Button';
import { Link } from 'react-router-dom';
import anime from 'animejs';
import { useEffect } from 'react';

type Props = {
  id: string;
};

const Info = (props: Props) => {
  const animateImage = () => {
    anime({
      targets: '.poka',
      easing: 'easeInOutSine',
      duration: 1000,
      // scale: 1.1,
      translateY: '-= 15',
      direction: 'alternate', // (0% -> 100% -> 0%)
      loop: true,
    });
  };

  useEffect(() => {
    animateImage();
  }, []);
  return (
    <BlockWrapper id={props.id}>
      <BackgroundImage
        src='/images/background/planet3.png'
        top={250}
        left={-50}
        size={180}
      />
      <BackgroundImage
        src='/images/background/circle3.png'
        top={500}
        right={-30}
        size={221}
      />
      <BackgroundImage
        src='/images/background/circle.png'
        top={850}
        right={70}
        size={73}
      />
      <BackgroundImage
        src='/images/background/planet.png'
        top={870}
        right={200}
        size={165}
      />
      <BlockHeader>
        <BlockTitle>MINTING INFO</BlockTitle>
      </BlockHeader>
      <ItemListWrapper>
        <Column.First>
          <Contents.ImageWrapper>
            <Contents.Image
              className='poka'
              src='/images/gummy_young.gif'
              size={68}
            />
          </Contents.ImageWrapper>
          <div>
            <Contents.Header align='right'>[ 2ND - SALE ]</Contents.Header>
            <Contents.Title align='right'>
              경쟁 화이트리스트 세일
            </Contents.Title>
            <Contents.Content align='right'>
              일시 : 2022년 11월 22일 (화) 8PM
            </Contents.Content>
            <Contents.Content align='right'>
              가격 : 470 KLAY | 개수 : 300개
            </Contents.Content>
          </div>
          <Contents.ImageWrapper style={{ paddingBottom: 77 }}>
            <Contents.Image
              className='poka'
              src='/images/gummy_adult.gif'
              size={119}
            />
          </Contents.ImageWrapper>
        </Column.First>
        <Column.Second>
          <svg width='100%' height='100%' style={{ position: 'absolute' }}>
            <path
              id='road-line'
              d='m 10 0 l 0 900'
              stroke='rgba(255, 255, 255, .15)'
              strokeWidth={2}
              fill='none'
            />
            <circle r='10' cx='10' cy='10' fill='#fff' />
            <circle r='10' cx='10' cy='470' fill='#fff' />
            <circle r='10' cx='10' cy='900' fill='#fff' />
          </svg>
          <StickyWrapper>
            <StickySvg>
              <line
                id='road-line-effect'
                x1='10'
                x2='10.001'
                y1='0'
                y2='120'
                // d="m 10 20 l 0 100"
                stroke='url(#gradient)'
                strokeWidth={2}
              />
              <defs>
                <linearGradient id='gradient' x1='0%' x2='0%' y1='0' y2='100%'>
                  <stop stopColor='rgba(225, 255, 255, 0)' offset='0%' />
                  <stop stopColor='rgba(225, 255, 255, 1)' offset='100%' />
                </linearGradient>
              </defs>
            </StickySvg>
          </StickyWrapper>
        </Column.Second>
        <Column.Third>
          <div>
            <Contents.Header>[ PRE - SALE ]</Contents.Header>
            <Contents.Title>화이트리스트 세일</Contents.Title>
            <Contents.Content>
              일시 : 2022년 11월 21일 (월) 8PM
            </Contents.Content>
            <Contents.Content>가격 : 370 KLAY | 개수 : 300개</Contents.Content>
            <Link to='/mint'>
              <Button type='button' style={{ marginTop: 28 }}>
                GO MINTING
              </Button>
            </Link>
          </div>
          <Contents.ImageWrapper
            align='flex-start'
            style={{ paddingBottom: 131 }}
          >
            <Contents.Image className='poka' src='/images/poka.gif' size={67} />
          </Contents.ImageWrapper>
          <div>
            <Contents.Header>[ 3RD - SALE ]</Contents.Header>
            <Contents.Title>퍼블릭 세일</Contents.Title>
            <Contents.Content>
              일시 : 2022년 11월 23일 (수) 8PM
            </Contents.Content>
            <Contents.Content>가격 : 570 KLAY | 개수 : 300개</Contents.Content>
          </div>
        </Column.Third>
        <Column.Hidden>
          <div>
            <Contents.Header>[ PRE - SALE ]</Contents.Header>
            <Contents.Title>화이트리스트 세일</Contents.Title>
            <Contents.Content>
              일시 : 2022년 11월 21일 (월) 8PM
            </Contents.Content>
            <Contents.Content>가격 : 370 KLAY | 개수 : 300개</Contents.Content>
            <Link to='/mint'>
              <Button type='button' style={{ marginTop: 28 }}>
                GO MINTING
              </Button>
            </Link>
          </div>
          <div>
            <Contents.Header>[ 2ND - SALE ]</Contents.Header>
            <Contents.Title>경쟁 화이트리스트 세일</Contents.Title>
            <Contents.Content>
              일시 : 2022년 11월 22일 (화) 8PM
            </Contents.Content>
            <Contents.Content>가격 : 470 KLAY | 개수 : 300개</Contents.Content>
          </div>
          <div>
            <Contents.Header>[ 3RD - SALE ]</Contents.Header>
            <Contents.Title>퍼블릭 세일</Contents.Title>
            <Contents.Content>
              일시 : 2022년 11월 23일 (수) 8PM
            </Contents.Content>
            <Contents.Content>가격 : 570 KLAY | 개수 : 300개</Contents.Content>
          </div>
        </Column.Hidden>
      </ItemListWrapper>
    </BlockWrapper>
  );
};

const ItemListWrapper = styled(BlockContentWrapper)`
  flex-direction: row;
  gap: 0;
  justify-content: space-between;
  max-width: 1200px;
  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    justify-content: center;
  }
`;

const Column = {
  First: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-basis: 49%;
    min-height: 1020px;
    box-sizing: border-box;

    @media (max-width: ${CUSTOM_BREAK_POINT}px) {
      display: none;
    }
  `,
  Second: styled.div`
    position: relative;
    display: flex;
    width: 30px;
    min-height: 1020px;
    flex-basis: 30px;
    margin: 0 88px;

    @media (max-width: ${CUSTOM_BREAK_POINT}px) {
      margin: 0 44px;
    }
  `,
  Third: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 1020px;
    box-sizing: border-box;
    flex-basis: 49%;

    @media (max-width: ${CUSTOM_BREAK_POINT}px) {
      display: none;
    }
  `,

  Hidden: styled.div`
    display: none;
    flex-direction: column;
    justify-content: space-between;
    min-height: 1020px;
    box-sizing: border-box;
    flex-basis: 49%;

    @media (max-width: ${CUSTOM_BREAK_POINT}px) {
      display: flex;
    }
  `,
};

const Contents = {
  Wrapper: styled.div``,
  Header: styled.p<{ align?: string }>`
    font-size: 22px;
    font-weight: 600;
    line-height: 32px;

    text-align: ${(props) => (props.align ? props.align : 'default')};
  `,
  Title: styled.p<{ align?: string }>`
    font-size: 40px;
    font-weight: 600;
    line-height: 62px;
    margin-bottom: 4px;

    text-align: ${(props) => (props.align ? props.align : 'default')};
  `,
  Content: styled.p<{ align?: string }>`
    font-size: 20px;
    line-height: 32px;

    text-align: ${(props) => (props.align ? props.align : 'default')};
  `,
  ImageWrapper: styled.div<{ align?: string }>`
    align-self: ${(props) => (props.align ? props.align : 'flex-end')};
  `,
  Image: styled.img<{ size: number }>`
    width: fit-content;
    height: ${(props) => props.size}px;
  `,
};

const StickyWrapper = styled.div`
  height: 900px;
`;

const StickySvg = styled.svg`
  position: sticky;
  width: 100%;
  height: 120px;
  top: 30%;
`;

export default Info;
